import { render, staticRenderFns } from "./checkboxBlog.vue?vue&type=template&id=4124196a&scoped=true&"
import script from "./checkboxBlog.vue?vue&type=script&lang=js&"
export * from "./checkboxBlog.vue?vue&type=script&lang=js&"
import style0 from "./checkboxBlog.vue?vue&type=style&index=0&id=4124196a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4124196a",
  null
  
)

export default component.exports